<template>
    <div v-if="!hideRateTableHeaderFilters && !hideRateTableFooterAndHeader" class="rates-table-form-container">
        <form class="row" @submit="submit">
            <div v-if="showCreditLimit" class="input-container col-12 col-md-5">
                <MoneyField
                    name="loanAmount"
                    :label="$t('form.fields.creditLimit.label')"
                    :customErrorMessage="$t('form.fields.creditLimit.errorMessage')"
                    :validationRules="{
                        required: true,
                    }"
                    :maxlength="9"
                    vuexKey="internal"
                />
            </div>

            <div class="input-container col-12 col-md-5" :class="{ 'col-md-6': !showCreditLimit }">
                <SelectField
                    name="cardType"
                    :customErrorMessage="$t('form.fields.cardType.errorMessage')"
                    :label="$t('form.fields.cardType.label')"
                    icon="fas fa-credit-card"
                    :options="cardTypes"
                    :validationRules="{
                        required: true,
                    }"
                    vuexKey="internal"
                    :defaultOption="defaultCardType"
                />
            </div>

            <div class="input-container col-12 col-md-2 end-right">
                <button
                    class="btn button secondary submit-button"
                    id="continue-button"
                    type="submit"
                    :disabled="searching"
                >
                    {{ searching ? 'Searching' : 'Submit' }}

                    <div
                        class="spinner-border spinner-border-sm text-light ml-1"
                        role="status"
                        v-show="searching"
                    ></div>
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import { useStore } from 'vuex'
import { useForm } from 'vee-validate'
import get from 'lodash/get'

export default {
    setup() {
        const store = useStore()
        const { validate } = useForm()

        return {
            store,
            validate,
        }
    },
    data() {
        return {}
    },
    computed: {
        cardTypes: function () {
            const cardTypes = this.$i18n.messages[this.$i18n.locale].form.fields.cardType.options
            cardTypes.unshift({ name: this.$t('form.fields.cardType.allCardsOption') || 'All cards', value: 'all' })
            return cardTypes
        },
        defaultCardType() {
            return this.cardTypes[0].value
        },
        searching: function () {
            return this.store.state.ratesTable.searching
        },
        showCreditLimit: function () {
            return this.store?.state?.global?.page?.extras?.hide_credit_limit || false
        },
        hideRateTableHeaderFilters: function () {
            return get(this.store, 'state.global.page.extras.toggle_rate_table_header', false)
        },
        hideRateTableFooterAndHeader: function () {
            return get(this.store, 'state.global.page.extras.toggle_all_rate_table_filters', false)
        },
    },
    methods: {
        submit: async function (e) {
            e.preventDefault()

            const { valid } = await this.validate()

            if (valid) {
                this.emitter.emit('submitRatesTable')
            }
        },
    },
}
</script>

<style lang="scss">
@import '~scss/mixins/rem';
@import '~scss/settings/responsive';

.rates-table-form-container {
    label {
        font-size: 0.78rem;
        padding-left: 0.5rem;
    }
    input[type='checkbox'] {
        outline: none;
        box-shadow: none;
    }
    .input-container {
        margin-bottom: 10px;

        @media screen and (min-width: $bp-large) {
            padding: 5px;
        }
    }

    .end-left {
        @media screen and (min-width: $bp-large) {
            padding-left: 15px;
        }
    }

    .end-right {
        @media screen and (min-width: $bp-large) {
            padding-right: 15px;
        }
    }

    .submit-button {
        line-height: 53px;
    }
}
</style>
